import React, { useEffect } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

function backendBaseForCallback() {
  const origin = window.location.origin;
  const isLocalhost = origin.includes("localhost") || origin.includes("127.0.0.1");
  if (!isLocalhost) return origin;
  return BACKEND_URL;
}

export function DiscordCallbackPage() {
  const params = new URLSearchParams(window.location.search);
  const code = params.get("code");
  const state = params.get("state"); // contains the frontend origin from login
  const err = params.get("error");
  const error = err ? String(err) : !code ? "Missing OAuth code" : null;

  useEffect(() => {
    if (!error && code) {
      // Hand off to backend to exchange code, set cookie, then redirect to '/'
      const base = backendBaseForCallback();
      const frontendOrigin = state || window.location.origin;
      window.location.assign(
        `${base}/api/auth/discord/callback?code=${encodeURIComponent(code)}&frontend_origin=${encodeURIComponent(frontendOrigin)}`,
      );
    }
  }, [code, error, state]);

  return (
    <div
      data-testid="discord-callback"
      className="min-h-screen bg-background text-foreground"
    >
      <div className="mx-auto max-w-3xl px-4 py-14">
        <div
          data-testid="discord-callback-card"
          className="rounded-2xl border border-border/60 bg-card/70 p-6"
        >
          <div
            data-testid="discord-callback-title"
            className="text-2xl font-semibold"
          >
            Connecting Discord…
          </div>
          <div
            data-testid="discord-callback-subtitle"
            className="mt-2 text-sm text-muted-foreground"
          >
            We’re finalizing your login.
          </div>

          {error ? (
            <div
              data-testid="discord-callback-error"
              className="mt-4 rounded-xl border border-rose-500/20 bg-rose-500/10 px-3 py-2 text-sm text-rose-700 dark:text-rose-300"
            >
              {error}
            </div>
          ) : (
            <div
              data-testid="discord-callback-loading"
              className="mt-4 text-sm text-muted-foreground"
            >
              Redirecting…
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
